export default "__VITE_ASSET__BoDAE$WO__"